import React from "react";
import classes from "./Team.module.css";
import emma from "../../Assets/emma.png";
import {CardSingle} from "../../UI/Cards";
import Button from "react-bootstrap/Button";

const DrEmma = () => {
    return (
        <div className={classes.Intro}>
            <h1 className={classes.focusLine}>
                <span>DR. EMMA WHELPTON DC</span>
            </h1>
            <CardSingle>
                <div className={classes.blackcard}>
                    <img
                        className={classes.portrait}
                        src={emma}
                        alt=""
                    />
                </div>
                <div className={classes.container1}>
                    <p>
                        Emma is a chiropractic doctor, movement specialist, and breath coach whose commitment to
                        holistic well-being extends beyond the clinic.
                        <br/>
                        <br/>
                        Emma's approach to healing is a blend of science and soul, recognizing the profound influence of
                        energetics and mindset on a healing journey. Within her health practice, she places a priority
                        on nurturing the mind, body, and breath, to find true well-being and soulful happiness.
                        <br/>
                        <br/>
                        When not working with clients, you can find Emma navigating between the sauna and cold plunge,
                        embodying a natural lifestyle and holistic health
                        <br/>
                        <br/>
                    </p>
                </div>

            </CardSingle>
            <a className={classes.bookSpecial} href="https://dremmawhelpton.janeapp.com/locations/amplify/book">
                <Button
                    variant="default"
                >
                    BOOK WITH DR. EMMA
                </Button>
            </a>
        </div>
    );
};

export default DrEmma;